<template>
  <header class="sideheader">
    <div
      data-grid
      class="sideheader__wrapper overflow-hidden grid--va-center"
    >
      <router-link
        :to="initialURL"
        class="sideheader__logo"
      >
        <slot name="logo">
          <img
            width="800"
            height="231"
            alt="Increazy"
            class="w-auto"
            :src="logo"
          >
        </slot>
      </router-link>
    </div>
  </header>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SideHeader',

  props: {
    logo: {
      type: Object,
      default: require('../../../assets/images/logos/increazy-dash-white.svg')
    }
  },

  computed: {
    initialURL () {
      return {
        name: 'checklist-home',
        params: {
          appID: this.$route.params.appID
        }
      }
    }
  }
})
</script>

<style lang="scss" scoped>
  .sideheader {
    background-color: var(--primary);

    // when dark mode is enabled
    .is-dark-theme & {
      background-color: rgb(var(--white-background-theme));
    }

    &__wrapper {
      padding-inline: 9px;
      height: var(--header-height);
    }

    &__logo {
      padding: 10px 0 0;
      transform: translateX(6px);

      :slotted(img) {
        width: auto;
        height: 50px;
        max-width: unset;
      }
    }

    @media (min-width: 1024px) {
      &__wrapper {
        padding-inline: 18px;
      }
    }
  }
</style>
